import { type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import {
	type FactFigureType,
	type FactFigureVariations,
	type FactStyleVariations,
} from '@/src/Types/Blocks/FactFigure';
import type { ContainerTypeEnums, PositionsAlignement } from '@/src/Types/Shared/Common';
import type { Options } from '@/src/Types/Shared/Options';
import { FactFigureStyle, getBtnStyle } from '@Views/Shared/GlobalStyles/GlobalStyles';

import Block from './Block';

type FactFigureRegister = {
	block: FactFigureType;
	variant: FactFigureVariations;
	containerType: ContainerTypeEnums;
	headingAlign: PositionsAlignement;
	wrapperType: ContainerTypeEnums;
	factFigureAlign: PositionsAlignement;
	factStyle: FactStyleVariations;
	options: Options;
};

export default function FactFigure(props: FactFigureRegister) {
	const {
		block,
		variant = 'classic',
		containerType = 'wide',
		headingAlign = 'center',
		wrapperType = 'block',
		factFigureAlign = 'center',
		factStyle = 'normal',
		options,
	} = props;

	const { id, title, description, titleFormat, columns, perRow = '3', composition } = block;

	let propsBlock: ComponentProps<typeof Block> = {
		id: id ? id : '',
		title: title,
		description: description,
		titleFormat: titleFormat,
		columns: columns,
		perRow: perRow,
		headingAlign: headingAlign,
		containerType: containerType,
		variant: variant,
		wrapperType: wrapperType,
		factFigureAlign: factFigureAlign,
		factStyle: factStyle,
		ctasStyle: getBtnStyle(options, options.blocks.factFigure.default.ctasStyle),
		style: {},
		contentFontFormats: block.contentFontFormats,
		placement: block.placement,
		sectionDecoration: options.layout.sectionDecoration,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(options.blocks.factFigure.compositions, { id: composition });
		if (compoOptions) {
			propsBlock = defu(compoOptions as ComponentProps<typeof Block>, propsBlock);
			propsBlock.ctasStyle = getBtnStyle(options, compoOptions.ctasStyle);
			propsBlock.style = FactFigureStyle(options, compoOptions);
		}
	}

	return <Block {...propsBlock} />;
}
